import {
  authHeader,
  handleResponse,
  errorOnActivation,
  handleWithClearErrorResponse,
} from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Limited Release By Region
function getLimitedReleaseByRegion(queryParams) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function createLimitedReleaseByRegion(requestBody, queryParams) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const { version } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function editLimitedReleaseByRegion(requestBody, queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function addTargetLimitedReleaseByRegion(requestBody, queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}/targets`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function removeTargetLimitedReleaseByRegion(queryParams) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { version, release, target } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}/targets/${target}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function deleteLimitedReleaseByRegion(queryParams) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function activateLimitedReleaseByRegion(queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}/activate`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(errorOnActivation)
    .then((data) => {
      return data;
    });
}

function deactivateLimitedReleaseByRegion(queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { version, release } = queryParams;
  const endPoint = `/api/admin/v1/releases/fuses/limited/${version}/${release}/deactivate`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

export const limitedReleasesRegionService = {
  getLimitedReleaseByRegion,
  createLimitedReleaseByRegion,
  editLimitedReleaseByRegion,
  addTargetLimitedReleaseByRegion,
  removeTargetLimitedReleaseByRegion,
  deleteLimitedReleaseByRegion,
  activateLimitedReleaseByRegion,
  deactivateLimitedReleaseByRegion,
};
